import { Fetch } from '.';
import { NodeType } from '../enums/NodeType';
import { Metadata, Schema, SchemaField } from '../types/Metadata';
import { RuleResponse } from '../types/RuleResponse';
import { ValidationResponse } from '../types/ValidationResponse';

export interface Payload {
  data: Partial<Metadata>;
  //schema: Schema;
  type: NodeType | string;
  refId: string;
  workspaceRefId?: string;
  viewRefId: string;
  validation: ValidationResponse;
  value: any;
  message: string;
  parentCommentRefId: string;
  srcRefId: string;
  isResolved: boolean;
  props: any;
  validateOnly: boolean;
  fields: SchemaField[];
  mentions: any[];
  additionalFieldsToValidate: string[];
  labels: NodeType[];
}

export const createData =
  (f: Fetch) =>
  async (payload: Pick<Payload, 'data'>): Promise<Metadata> =>
    f.fetchJSON<Metadata>(payload, '/mutation/data', 'POST');

export const updateData =
  (f: Fetch) =>
  async (payload: Pick<Payload, 'data'>): Promise<Metadata[]> =>
    f.fetchJSON<Metadata[]>(payload, '/mutation/data', 'PUT');

export const deleteData =
  (f: Fetch) =>
  async (
    payload: Pick<Payload, 'refId' | 'type'>
  ): Promise<{ data: Metadata; relationships: number }[]> =>
    f.fetchJSON<{ data: Metadata; relationships: number }[]>(
      payload,
      '/mutation/data',
      'DELETE'
    );

export const pushToCPP =
  (f: Fetch) =>
  async (
    payload: Pick<
      Payload,
      | 'data'
      | 'validation'
      | 'validateOnly'
      | 'workspaceRefId'
      | 'additionalFieldsToValidate'
    >
  ): Promise<ValidationResponse> =>
    f.fetchJSON<ValidationResponse>(payload, '/mutation/cpp', 'POST');

export const runRules =
  (f: Fetch) =>
  async (
    payload: Pick<Payload, 'data' | 'workspaceRefId'>
  ): Promise<RuleResponse> =>
    f.fetchJSON<RuleResponse>(payload, '/mutation/rules', 'POST');

export const createComment =
  (f: Fetch) =>
  async (
    payload: Pick<
      Payload,
      | 'message'
      | 'parentCommentRefId'
      | 'srcRefId'
      | 'isResolved'
      | 'mentions'
      | 'viewRefId'
      | 'workspaceRefId'
      | 'labels'
    >
  ): Promise<Metadata[]> =>
    f.fetchJSON<Metadata[]>(payload, '/mutation/comment', 'POST');

export const updateComment =
  (f: Fetch) =>
  async (payload: Pick<Payload, 'refId' | 'props'>): Promise<Metadata[]> =>
    f.fetchJSON<Metadata[]>(payload, '/mutation/comment', 'PUT');

export const deleteComment =
  (f: Fetch) =>
  async (payload: Pick<Payload, 'refId'>): Promise<Metadata[]> =>
    f.fetchJSON<Metadata[]>(payload, '/mutation/comment', 'DELETE');
